import { createAsyncThunk } from "@reduxjs/toolkit";

import { downloadFile } from "core/request_utils";

export const downloadSourceGgeSearchResult = createAsyncThunk(
	"sandbox/downloadSourceGgeSearchResult",
	async ({ taskId }, { rejectWithValue, extra }) => {
		try {
			const { data } = await extra.apiSandbox.downloadSourceGgeSearchResult({ taskId });

			if (!data) {
				throw new Error();
			}

			downloadFile({ data }, `SourceGgeSearchResult_${taskId}.zip`);
		} catch (e) {
			return rejectWithValue(e);
		}
	}
);
